import { css } from 'linaria';

export const text = css`
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  white-space: pre-wrap;
`;

export const content = css`
  display: flex;
  align-items: center;
`;
